// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-cajsq{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.assets-scss-gridstyleGrid-grid-bqate{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-bdacb{grid-column:span 6}.assets-scss-gridstyleGrid-col3-bgfip{grid-column:span 3}.assets-scss-gridstyleGrid-col4-skwwb{grid-column:span 4}.assets-scss-gridstyleGrid-col9-mxmrf{grid-column:span 9}.assets-scss-gridstyleGrid-col12-jjfly{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-xevew{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-cajsq",
	"grid": "assets-scss-gridstyleGrid-grid-bqate",
	"col6": "assets-scss-gridstyleGrid-col6-bdacb",
	"col3": "assets-scss-gridstyleGrid-col3-bgfip",
	"col4": "assets-scss-gridstyleGrid-col4-skwwb",
	"col9": "assets-scss-gridstyleGrid-col9-mxmrf",
	"col12": "assets-scss-gridstyleGrid-col12-jjfly",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-xevew"
};
module.exports = ___CSS_LOADER_EXPORT___;
